import React, { useState, useEffect } from "react";

import { FilterRule, FilterTypeButtons } from "./common/FilterRule";

import { Card } from "selfly-ui-react";

import "./filter-component.scss";

export default function AlarmFilters(props) {
    // Default set for filters set here
    const [severityFilter, setSeverityFilter] = useState({ critical: true, high: true, medium: true, low: true });
    const [timeFrame, setTimeFrame] = useState({ value: "all", negative: false });

    const [alarmTypes, setAlarmTypes] = useState({
        DockerDown: true,
        NetworkDown: true,
        networkError: true,
        readerError: true,
        SidHealthNotAvailable: true,
        other: true,
    });

    function severityFromValue(severityValue) {
        if (severityValue >= 0.8) return "critical";
        if (severityValue >= 0.6) return "high";
        if (severityValue >= 0.4) return "medium";
        return "low";
    }

    // Build Rules
    useEffect(() => {
        const rules = [];

        rules.push({
            key: "severity",
            rule: sev => {
                const sevLevel = severityFromValue(sev);
                return severityFilter[sevLevel] === true;
            },
        });

        rules.push({
            key: "type",
            rule: type => {
                if (alarmTypes[type] === undefined && alarmTypes.other === true) {
                    return true;
                }
                return alarmTypes[type] === true;
            },
        });

        if (timeFrame.value !== "all") {
            const timeInMs = timeFrameToMs(timeFrame.value);
            rules.push({
                key: "lastTimeSeen",
                rule: val => {
                    return Date.parse(val) > timeInMs;
                },
                not: timeFrame.negative,
            });
        }

        props.onChange(rules);
    // eslint-disable-next-line
    }, [severityFilter, timeFrame, alarmTypes]);

    return (
        <div className="filter-component alarm-filter">
            <Card title="Alarm Filter">
                <FilterRule
                    name="Alarm Levels"
                    typeComponent={FilterTypeButtons}
                    value={severityFilter}
                    valueSet={setSeverityFilter}
                    options={{
                        multiSelect: true,
                        buttons: [
                            {
                                text: "Critical",
                                value: "critical",
                            },
                            {
                                text: "High",
                                value: "high",
                            },
                            {
                                text: "Medium",
                                value: "medium",
                            },
                            {
                                text: "Low",
                                value: "low",
                            },
                        ],
                    }}
                />

                <FilterRule
                    name="Alarm Types"
                    typeComponent={FilterTypeButtons}
                    value={alarmTypes}
                    valueSet={setAlarmTypes}
                    options={{
                        multiSelect: true,
                        buttons: [
                            {
                                text: "Docker Down",
                                value: "DockerDown",
                            },
                            {
                                text: "Network Down",
                                value: "NetworkDown",
                            },
                            {
                                text: "Network Error",
                                value: "networkError",
                            },
                            {
                                text: "Reader Error",
                                value: "readerError",
                            },
                            {
                                text: "No Health Status",
                                value: "SidHealthNotAvailable",
                            },
                            {
                                text: "Other",
                                value: "other",
                            },
                        ],
                    }}
                />

                <FilterRule
                    name="Timeframe"
                    help="Show only alarms from the timeframe selected. Counting starts from this moment into the history"
                    typeComponent={FilterTypeButtons}
                    value={timeFrame.value}
                    negative={timeFrame.negative}
                    valueSet={setTimeFrame}
                    options={{
                        buttons: [
                            {
                                text: "ALL",
                                value: "all",
                            },
                            {
                                text: "1 hour",
                                value: "hour",
                            },
                            {
                                text: "3 hours",
                                value: "3hours",
                            },
                            {
                                text: "1 day",
                                value: "day",
                            },
                            {
                                text: "1 week",
                                value: "week",
                            },
                            {
                                text: "30 days",
                                value: "month",
                            },
                            {
                                text: "1 Year",
                                value: "year",
                            },
                        ],
                    }}
                />
            </Card>
        </div>
    );
}

function timeFrameToMs(timeframe) {
    switch (timeframe) {
        case "hour":
            return Date.now() - 3600 * 1000;
        case "3hours":
            return Date.now() - 3600 * 1000 * 3;
        case "day":
            return Date.now() - 3600 * 1000 * 24;
        case "week":
            return Date.now() - 3600 * 1000 * 24 * 7;
        case "month":
            return Date.now() - 3600 * 1000 * 24 * 30;
        case "year":
            return Date.now() - 3600 * 1000 * 24 * 365;
        case "all":
        default:
            return 0;
    }
}
